<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <span class="bold">Converted Pendancy</span>
        </div>
        <div class="row ">
            <div class="col-sm-3">
                <mat-form-field appearance="fill">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate #dateRangeStart placeholder="Start date">
                        <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeBucketWise(dateRangeStart, dateRangeEnd)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <mat-icon (click)="clearDate(1)">clear</mat-icon>
            </div>
            <div class="col-sm-2 mt-2">
                <mat-select  placeholder="Select Treatment" (selectionChange)="getBucketWisePendingPayment()" [(ngModel)]="bucket_treatment">
                    <mat-option >Select Treatment</mat-option>
                    <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatList">{{ltreatment.name}}</mat-option>
                </mat-select>
            </div>
            <!-- <div class="col-sm-2 mt-2">
                <button type="button" class="btn btn-success ml-2" [disabled]="bucket_wise_pending_payment_loading" (click)="exportBucketWisePendingPayment()"><i class="fa fa-file-excel"></i> Export List</button>
            </div> -->
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th colspan="4"><b>Circle Wise</b></th>
                                <th colspan="5"><b>Bucket Wise Pending Payments</b></th>
                            </tr>
                            <tr class="text-center">
                                <th>Circle</th>
                                <th>Total Leads</th>
                                <th>SD</th>
                                <th>Converted</th>
                                <th>Overall Pending</th>
                                <th>Below 15</th>
                                <th>Above 15</th>
                                <th>Above 30</th>
                                <th>Above 45</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of bucketWisePendingPayment" >
                                <td>{{tdata.name}}</td>
                                <td>{{tdata.lead_count | number : '1.0-0'}}</td>
                                <td>{{tdata.sd | number : '1.0-0'}}</td>
                                <td>{{tdata.converted | number : '1.0-0'}}</td>
                                <td>{{tdata.below_15+tdata.above_15+tdata.above_30+tdata.above_45 | number : '1.0-0'}}</td>
                                <td>{{tdata.below_15 | number : '1.0-0'}}</td>
                                <td>{{tdata.above_15 | number : '1.0-0'}}</td>
                                <td>{{tdata.above_30 | number : '1.0-0'}}</td>
                                <td>{{tdata.above_45 | number : '1.0-0'}}</td>
                            </tr> 
                            <tr *ngIf="bucket_wise_pending_payment_loading">
                                <td colspan="9" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <td><b>Overall</b></td>
                                <td><b>{{total_lead_count | number : '1.0-0'}}</b></td>
                                <td><b>{{total_sd | number : '1.0-0'}}</b></td>
                                <td><b>{{total_converted | number : '1.0-0'}}</b></td>
                                <td><b>{{total_overall_pending | number : '1.0-0'}}</b></td>
                                <td><b>{{total_below_15 | number : '1.0-0'}}</b></td>
                                <td><b>{{total_above_15 | number : '1.0-0'}}</b></td>
                                <td><b>{{total_above_30 | number : '1.0-0'}}</b></td>
                                <td><b>{{total_above_45 | number : '1.0-0'}}</b></td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
    </div>
</div>
